import { render, staticRenderFns } from "./idspProtocol.vue?vue&type=template&id=27d75404&scoped=true"
import script from "./idspProtocol.vue?vue&type=script&lang=js"
export * from "./idspProtocol.vue?vue&type=script&lang=js"
import style0 from "./idspProtocol.vue?vue&type=style&index=0&id=27d75404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d75404",
  null
  
)

export default component.exports